import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4be4bb9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_routing_overview_batch_refund ",
  ref: "orderRoutingBatchRefundModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-800px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_routing_overview_batch_refund_header"
}
const _hoisted_5 = { class: "w-100 d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "modal-body px-10 py-5" }
const _hoisted_11 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed p-6 mb-10"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle fs-2tx text-primary" }, null, -1))
const _hoisted_13 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_14 = { class: "fs-6 text-gray-800 ps-5" }
const _hoisted_15 = { class: "notice d-flex rounded border-gray-300 border border-dashed px-6 py-2 mb-10" }
const _hoisted_16 = { class: "table align-middle mb-0" }
const _hoisted_17 = { class: "mb-0 fs-7 text-line-clamp-1 text-gray-400" }
const _hoisted_18 = { class: "mb-0 fs-7 text-line-clamp-1 text-gray-400" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "table align-middle table-row-bordered border-bottom fs-6 gy-5" }
const _hoisted_21 = { class: "text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_25 = ["onUpdate:modelValue", "disabled"]
const _hoisted_26 = { class: "pe-5" }
const _hoisted_27 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix justify-content-end" }
const _hoisted_28 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_29 = { class: "fw-bold fs-4 mb-5 d-flex justify-content-between" }
const _hoisted_30 = { class: "flex-1 text-end" }
const _hoisted_31 = { class: "modal-footer flex-right" }
const _hoisted_32 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "indicator-label" }
const _hoisted_35 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_36 = { class: "indicator-progress" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.t("orderRefund.refundSettings")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_ctx.totalRefundComputed != Number(_ctx.props.product.total))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("orderRefund.submitTip.notMatchPrice")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_product_info, {
                        gallery: [
                          { id: _ctx.product.guid, origin_url: _ctx.product.image },
                        ],
                        name: _ctx.product.name,
                        name_en: _ctx.product.name_en,
                        brand_id: _ctx.product.brand
                      }, null, 8, ["gallery", "name", "name_en", "brand_id"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.t("orderRefund.product.guid")) + ": " + _toDisplayString(_ctx.product.guid), 1),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.t("orderRefund.product.sku")) + ": " + _toDisplayString(_ctx.product.brand_article_no
                              ? _ctx.product.brand_article_no
                              : _ctx.product.merchant_article_no), 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$currency.currency(_ctx.product.total, 2, ",", ".", "€ ")), 1)
                  ])
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_20, [
              _createElementVNode("colgroup", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                  return _createElementVNode("col", {
                    key: n,
                    style: _normalizeStyle({ width: _ctx.getColumnWidth(n - 1) })
                  }, null, 4)
                }), 64))
              ]),
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("th", null, _toDisplayString(_ctx.t("orderRefund.paymentDocument")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.t("orderRefund.remainingAmount")), 1),
                  _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.t("orderRefund.refundAmount")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentDocumentList, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: _normalizeClass({
                    'bg-gray-100 disabled': Number(item.refundable_amount) <= 0,
                  })
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_24, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((_ctx.formData[index].is_selected) = $event),
                          class: "form-check-input",
                          type: "checkbox",
                          disabled: Number(item.refundable_amount) <= 0
                        }, null, 8, _hoisted_25), [
                          [_vModelCheckbox, _ctx.formData[index].is_selected]
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(item.pay_order_no), 1),
                    _createElementVNode("td", null, _toDisplayString(item.currency == "CNY"
                        ? _ctx.$currency.currency(
                            item.refundable_amount,
                            2,
                            ".",
                            "",
                            "￥ "
                          )
                        : _ctx.$currency.currency(
                            item.refundable_amount,
                            2,
                            ",",
                            ".",
                            "€ "
                          )), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_el_input_number, {
                          class: "w-90px size-sm text-end",
                          modelValue: _ctx.formData[index].apply_refund_amount,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.formData[index].apply_refund_amount) = $event),
                          precision: 2,
                          step: 0.01,
                          min: 0,
                          max: Number(item.refundable_amount),
                          controls: false,
                          disabled: Number(item.refundable_amount) <= 0
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "max", "disabled"]),
                        _createElementVNode("div", _hoisted_28, _toDisplayString(item.currency == "CNY" ? "￥" : "€"), 1)
                      ])
                    ])
                  ], 2))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.t("orderRefund.totalRefund")) + " : ", 1),
              _createElementVNode("div", {
                class: _normalizeClass(["min-w-150px text-end fw-bolder", {
                  'text-danger':
                    _ctx.totalRefundComputed != Number(_ctx.props.product.total),
                }])
              }, _toDisplayString(_ctx.$currency.currency(_ctx.totalRefundComputed, 2, ",", ".", "€ ")), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", {
              type: "button",
              class: "btn btn-light me-3",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.modalHide && _ctx.modalHide(...args)))
            }, [
              _createElementVNode("span", _hoisted_32, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.cancel")), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-lg btn-primary",
              disabled: 
                _ctx.totalRefundComputed <= 0 ||
                _ctx.totalRefundComputed != Number(_ctx.props.product.total)
              ,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmitButtonClick && _ctx.onSubmitButtonClick(...args)))
            }, [
              _createElementVNode("span", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
              ]),
              _createElementVNode("span", _hoisted_36, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_37
              ])
            ], 8, _hoisted_33)
          ])
        ])
      ])
    ])
  ], 512))
}